import { useContext, useEffect, useMemo, useState } from "react";
import { FilterContext } from "src/components/Common/UI/DndTable/TableFilterV2/FilterContext";
import { useGetAllPendingStatus } from "../api/getAllPendingStatus";
import { useTranslation } from "react-i18next";

// All your logic is here
export const usePendingStatusDataViewLogic = () => {
  const { submitedFilters } = useContext(FilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({ action: "", selectedRows: [] });
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetPendingStatus []>([]);
  const getAllPendingStatusQuery = useGetAllPendingStatus({data: submitedFilters ? submitedFilters : {}});
  const { t } = useTranslation();

  const loadingDone = [getAllPendingStatusQuery].every(
    ({ isFetching  }) => !isFetching
  );

  const errorData = [getAllPendingStatusQuery].filter(
    ({ isError }) => (isError ? true : false)
  );

  const data = getAllPendingStatusQuery.data ? getAllPendingStatusQuery.data : []

  const columns = useMemo(
    () => [
      {
          id: "1",
          Header: "Κατηγορία Εκκρεμότητας",
          accessor: "description",
          show : true,
          isDraggable: false,
      },
  
    ], []
  );

  const closeActionModal = () => {
    setModalEvent({action: "", selectedRows: []});
  }

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Κατηγορίας Εκκρεμότητας");
        break;
      case "edit":
        title = t("Επεξεργασία Κατηγορίας Εκκρεμότητας");
        break
        case "delete":
        title = t("Διαγραφή Κατηγορίας Εκκρεμότητας");
        break
      default:
        break;
    }
    return title;
  }

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0] ? [...[selectedRowsOfTable[0].id]] : [];
    console.log("selectedRows", selectedRows, "selectedRowOfTable", selectedRowsOfTable, "selectedRowOfTable[0]", selectedRowsOfTable[0])
    setModalEvent({action: event.action, selectedRows: selectedRows})
  }

  useEffect(()=>{
    setSelectedRowsOfTable([]);
    getAllPendingStatusQuery.refetch();
  },[ submitedFilters ])


  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction
  };
};
